export enum StatusAccountEnum {
  ACTIVE = 1,
  PENDING_TO_CONFIRM_EMAIL = 2,
  INACTIVE = 3
}